'use client';

import { useBoolean } from '@insta-club/hooks';
import { Transaction } from '@insta-club/models';
import { BottomSheet } from '@insta-club/ui';
import { formatDate, isPositive, separator } from '@insta-club/utilities';
import { ChevronIcon, DecreaseIcon, IncreaseIcon, Toman } from 'src/libs/components/icons';
import CalenderIcon from 'src/libs/components/icons/calender';

function TransactionItem({ item }: { item: Transaction }) {
    const sheetIsOpen = useBoolean();
    return (
        <>
            <div onClick={sheetIsOpen.onTrue} className='cursor-pointer space-y-2 rounded-[12px] bg-gray-100 p-4'>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center space-x-1.5'>
                        {!isPositive(item.amount) ? (
                            <DecreaseIcon className='text-red-400' />
                        ) : (
                            <IncreaseIcon className='text-green-400' />
                        )}
                        <div className='flex items-start space-x-1'>
                            <span dir='ltr' className='text-base font-semibold text-gray-800'>
                                {separator(item.amount)}
                            </span>
                            <Toman width={18} height={18} />
                        </div>
                    </div>
                    <div className='flex items-center space-x-1'>
                        <span className='text-sm font-medium text-gray-800'>جزئیات</span>
                        <ChevronIcon width={16} height={16} />
                    </div>
                </div>
                <p className='text-sm font-medium text-gray-500'>
                    {item?.description ? item?.description : <>شرح ندارد</>}
                </p>
                <div className='flex items-center justify-end space-x-1'>
                    <CalenderIcon className='text-gray-500' />
                    <span className='text-xs font-medium text-gray-500'>{formatDate(item.created_at)}</span>
                </div>
            </div>
            <BottomSheet open={sheetIsOpen.value} title={'جزئیات تراکنش'} onClose={sheetIsOpen.onFalse}>
                <div className='flex flex-col items-center justify-center space-y-4'>
                    <svg width='65' height='64' viewBox='0 0 65 64' fill='none' xmlns='http://www.w3.org/2000/svg'>
                        <rect x='0.5' width='64' height='64' rx='16' fill='#F3F4F6' />
                        <path
                            d='M37.5403 18.6669H27.4603C22.4203 18.6669 21.167 20.0135 21.167 25.3869V40.4002C21.167 43.9469 23.1137 44.7869 25.4737 42.2535L25.487 42.2402C26.5803 41.0802 28.247 41.1735 29.1937 42.4402L30.5403 44.2402C31.6203 45.6669 33.367 45.6669 34.447 44.2402L35.7937 42.4402C36.7537 41.1602 38.4203 41.0669 39.5137 42.2402C41.887 44.7735 43.8203 43.9335 43.8203 40.3869V25.3869C43.8337 20.0135 42.5803 18.6669 37.5403 18.6669ZM36.5003 31.6669H28.5003C27.9537 31.6669 27.5003 31.2135 27.5003 30.6669C27.5003 30.1202 27.9537 29.6669 28.5003 29.6669H36.5003C37.047 29.6669 37.5003 30.1202 37.5003 30.6669C37.5003 31.2135 37.047 31.6669 36.5003 31.6669ZM37.8337 26.3335H27.167C26.6203 26.3335 26.167 25.8802 26.167 25.3335C26.167 24.7869 26.6203 24.3335 27.167 24.3335H37.8337C38.3803 24.3335 38.8337 24.7869 38.8337 25.3335C38.8337 25.8802 38.3803 26.3335 37.8337 26.3335Z'
                            fill='#6262BE'
                        />
                    </svg>
                    <div className='flex items-start space-x-1'>
                        <span dir='ltr' className='text-xl font-semibold text-gray-800'>
                            {separator(item.amount)}
                        </span>
                        <Toman width={18} height={18} />
                    </div>
                    <div className='flex w-full items-center justify-between rounded-xl bg-gray-100 p-4'>
                        <span className='text-sm font-normal text-gray-500'>تاریخ پرداخت</span>
                        <span className='text-sm font-semibold text-gray-800'>{formatDate(item.created_at)}</span>
                    </div>
                    <div className='flex w-full items-center justify-between rounded-xl bg-gray-100 p-4'>
                        <span className='text-sm font-normal text-gray-500'>کد پیگیری</span>
                        <span className='text-sm font-semibold text-gray-800'>{item.id}</span>
                    </div>
                    <div className='flex w-full items-center justify-between rounded-xl bg-gray-100 p-4'>
                        <span className='text-sm font-normal text-gray-500'>خرید اشتراک</span>
                        <span className='text-sm font-semibold text-gray-800'>{item.type_fa}</span>
                    </div>
                    <div className='flex w-full flex-col space-y-3 rounded-xl bg-gray-100 p-4'>
                        <span className='text-sm font-normal text-gray-500'>توضیحات</span>
                        <span className='text-sm font-semibold text-gray-800'>{item.description}</span>
                    </div>
                </div>
            </BottomSheet>
        </>
    );
}

export default TransactionItem;

